import { Box, styled } from '@mui/material'
import { forwardRef, ForwardedRef, CSSProperties, ReactNode } from 'react'
import { typography } from 'ComponentLibrary/src/styles'
import palette from 'ComponentLibrary/src/styles/colors'

export type TypographyVariantTypes = keyof typeof typography.fonts

export interface TypographyProps {
    children?: ReactNode
    variant?: TypographyVariantTypes
    className?: string
    color?: string
    style?: CSSProperties
    align?: 'left' | 'center' | 'right'
    onClick?: (() => void) | ((event: React.MouseEvent<HTMLElement, MouseEvent>) => void)
    onDoubleClick?: (() => void) | ((event: React.MouseEvent<HTMLElement, MouseEvent>) => void)
    gutterBottom?: boolean
    role?: string
    id?: string
}

export const DEFAULT_VARIANT = 'bodyTextLarge'

export const GUTTER_BOTTOM = '0.35em'

/**
 @deprecated please use piazza/text instead
 */
const Typography = forwardRef(
    (
        {
            align,
            style,
            children,
            variant = DEFAULT_VARIANT,
            className,
            color,
            onClick,
            onDoubleClick,
            gutterBottom = false,
            role,
            id,
            ...ariaAttributes
        }: TypographyProps,
        ref: ForwardedRef<HTMLDivElement>
    ) => {
        const styleOverrides: CSSProperties = {
            textAlign: align,
            marginBottom: gutterBottom ? GUTTER_BOTTOM : undefined,
            ...style,
        }

        return (
            <Box
                ref={ref}
                id={id}
                className={className}
                sx={{
                    ...typography.fonts[variant],
                    fontFamily: typography.fontFamily,
                    color: color || typography.fonts[variant]?.color || palette.customtext.darkblue100,
                    textTransform: typography.fonts[variant]?.textTransform || 'none',
                }}
                style={styleOverrides}
                onClick={onClick}
                onDoubleClick={onDoubleClick}
                role={role}
                {...ariaAttributes}
            >
                {children}
            </Box>
        )
    }
)

export const TypographyWithSeparator = styled(Typography)`
    width: fit-content;
    display: inline;
    &:not(:first-of-type) {
        margin-left: 0.25rem;

        &::before {
            content: '|';
            margin-right: 0.25rem;
        }
    }
`

type TypographyWithDecoratorProps = {
    decorator?: string
}

export const TypographyWithDecorator = styled(Typography)<TypographyWithDecoratorProps>`
    width: fit-content;
    display: inline;
    &::before {
        content: '${(props) => props.decorator}';
    }
`

export default Typography
